import isEmpty from "lodash/isEmpty";
/* eslint-disable import/prefer-default-export */
export const filterIncludeCaseInsensitive = (f, row) =>
  isEmpty(f.value) || (f && f.value && row && row[f.id] && row[f.id].toLowerCase().includes(f.value.toLowerCase()));

export const mergeArrays = (a, b, key) => a.filter(aa => !b.find(bb => aa[key] === bb[key])).concat(b);
